import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
	standalone: true,
	selector: 'app-footer',
	imports: [RouterLink],
	templateUrl: './footer.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './footer.css',
})
export class FooterComponent {
	currentYear = new Date().getFullYear()
}
